import Icon from '../components/Icon';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { readSaved } from '../gameDeck';
import PlayerAvatar from '../components/PlayerAvatar';
export default function ResultsPage() {
  const { urlGameCode: code } = useParams();
  const players = [...(readSaved(code + '_data', {}).readyPlayers || [])].sort((a,b) => b.score - a.score);
  const winners = players.filter(p => p.score === players[0]?.score).map(p => p.name).join(' & ');
  return <div className="empty-state"><Icon name="sun" className="big-symbol" /><span className="eyebrow">THE TABLE HAS SPOKEN</span><h1>{winners || 'What a round.'}</h1><p>{players.filter(p => p.score === players[0]?.score).length > 1 ? 'Share the crown. You earned it.' : 'Officially knows the group a little too well.'}</p>
    <div className="score-list">{players.map((p, i) => <div key={p.playerId || p.name}><span className="creative-person-line"><PlayerAvatar player={p} /><span>{i + 1}. {p.name}</span></span><strong>{p.score} pts</strong></div>)}</div>
    <Link className="button dark" to="/">Play again <Icon name="arrow-right" /></Link><Link className="text-link" to="/simple-mode/personalize">Try a ready-made deck</Link>
  </div>;
}
